export enum Queries {
    getRecommendedProgramsList = 'getRecommendedProgramsList',
}
